import { render } from "./RegisterSeller.vue?vue&type=template&id=3a385c68&scoped=true"
import script from "./RegisterSeller.vue?vue&type=script&lang=js"
export * from "./RegisterSeller.vue?vue&type=script&lang=js"

import "@/assets/css/layout_registerSeller.css?vue&type=style&index=0&id=3a385c68&scoped=true&lang=css"
import "./RegisterSeller.vue?vue&type=style&index=1&id=3a385c68&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a385c68"]])

export default __exports__